import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const location = useLocation();
  const [showPlayPopup, setShowPlayPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  if (location.pathname.startsWith('/event/')) return null;
  if (location.pathname.startsWith('/vote/')) return null;

  const isAdminPage = location.pathname === '/panel' || location.pathname.startsWith('/panel/');

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePlayClick = () => {
    setShowPlayPopup(true);
    setIsClosing(false);
    navigator.clipboard.writeText('thetopia.net');
    setCopied(true);
  };

  const handleClosePopup = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowPlayPopup(false);
      setIsClosing(false);
      setCopied(false);
    }, 300);
  };

  return (
    <footer className="footer">
      {!isAdminPage && (
        <div className="footer-cta">
          <div className="cta-section cta-play animate-fade-in">
            <div className="cta-content">
              <h3>Ready to Play?</h3>
              <p>Participate in our custom events!</p>
              <button className="btn btn-white btn-large" onClick={handlePlayClick}>Play Now</button>
            </div>
          </div>
          <div className="cta-section cta-discord animate-fade-in delay-1">
            <div className="cta-content">
              <h3>Join Our Community</h3>
              <p>Connect with other players on Discord</p>
              <a href="https://discord.thetopia.net" target="_blank" rel="noopener noreferrer" className="btn btn-outline btn-large">Join Discord</a>
            </div>
          </div>
        </div>
      )}

      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-logo">
            <img src="/text_logo.png" alt="TheTopia Logo" />
          </div>

          <div className="footer-links">

            <div className="footer-column">
              <h4>Community</h4>
              <a href="https://discord.thetopia.net" target="_blank" rel="noopener noreferrer">Discord</a>
              <Link to="/events" onClick={scrollToTop}>Events</Link>
            </div>

            <div className="footer-column">
              <h4>About Us</h4>
              <Link to="/creators" onClick={scrollToTop}>Owners</Link>
            </div>

            <div className="footer-column">
              <h4>Socials</h4>
              <a href="https://youtube.com/@lafless" target="_blank" rel="noopener noreferrer">lafless</a>
              <a href="https://youtube.com/@Evakz" target="_blank" rel="noopener noreferrer">Evakz</a>
            </div>

            <div className="footer-column">
              <h4>Staff</h4>
              <Link to="/panel" onClick={scrollToTop}>Staff Login</Link>
            </div>
          </div>
        </div>

        <div className="footer-legal">
          <p>&copy; 2026 TheTopia</p>
          <p>All Rights Reserved. We are not affiliated with Mojang AB.</p>
        </div>
      </div>

      {showPlayPopup && createPortal(
        <div className={`play-popup-overlay ${isClosing ? 'closing' : ''}`} onClick={handleClosePopup}>
          <div className={`play-popup ${isClosing ? 'closing' : ''}`} onClick={(e) => e.stopPropagation()}>
            <div className="play-popup-content">
              <h2 className="server-ip">thetopia.net</h2>
              {copied && <p className="copied-message">✓ Copied to clipboard!</p>}
              <div className="server-instructions">
                <h3>How to Join:</h3>
                <ol>
                  <li>Open Minecraft</li>
                  <li>Click "Multiplayer"</li>
                  <li>Click "Add Server"</li>
                  <li>Paste the server address</li>
                  <li>Click "Done" and join!</li>
                </ol>
              </div>
              <button className="close-popup-btn" onClick={handleClosePopup}>
                Close
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </footer>
  );
}
